import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { Switch, FormControlLabel } from '@mui/material';

// ----------------------------------------------------------------------

RHFSwitch.propTypes = {
  name: PropTypes.string
};

export default function RHFSwitch({ name, handleSwitchChange, ...other }) {
  const { control } = useFormContext();

  return (
    <FormControlLabel
      control={
        <Controller
          name={name}
          control={control}
          render={({ field }) =>
            <Switch {...field}
              onChange={(event, value) => {
                field.onChange(value);
                if (handleSwitchChange)
                  handleSwitchChange(value);
              }}
              checked={!!field.value} />}
        />
      }
      {...other}
    />
  );
}
